import cx from 'classix'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import i18n from '@src/config/i18n'

import HoverableArrow from '../HoverableArrow'
import { getResourcesLinks, getResourcesTabs } from '../constants/resources'
import MegaMenu from '../menu/MegaMenu'
import MegaMenuContent from '../menu/MegaMenuContent'

type Props = {
  open: boolean
}

export default function ResourcesTabMenu({ open }: Props) {
  const { t } = useTranslation('revamp')
  const [showResources, setShowResources] = useState(true)
  const [resourcesSelectedTab, setResourcesSelectedTab] = useState<number>(0)
  const locale = i18n.language

  const links = getResourcesLinks(t, locale)

  const resourcesTabs = getResourcesTabs(t, locale)
  const selectedSection = resourcesTabs[resourcesSelectedTab].section

  useEffect(() => {
    if (open) {
      setShowResources(true)
      setResourcesSelectedTab(0)
    }
  }, [open])

  return (
    <MegaMenu open={open}>
      <section className='flex flex-col items-start w-1/3'>
        <div className='flex flex-col items-start gap-8 text-r-3xl font-bold leading-none text-revamp-red-100'>
          <span
            onMouseEnter={() => setShowResources(true)}
            className={cx('underline-thick', showResources && 'text-white underline')}
          >
            {t('resources')}
          </span>
          {links.map((link) => (
            <a
              key={`resources_tab_${link.title}`}
              className='underline-thick hover:underline hover:text-white'
              onMouseEnter={() => setShowResources(false)}
              href={link.link}
            >
              {link.title}
            </a>
          ))}
        </div>
      </section>
      <MegaMenuContent showDivider={showResources}>
        <div className={cx('grid grid-cols-2 gap-12', showResources ? 'block' : 'hidden')}>
          <section className='flex flex-col gap-8 leading-mid font-bold text-revamp-red-100'>
            {resourcesTabs.map((tab, i) => (
              <a
                href={tab.section.link}
                onMouseEnter={() => setResourcesSelectedTab(i)}
                className={cx(
                  'font-bold text-left hover:underline',
                  resourcesSelectedTab === i && 'text-white'
                )}
                key={`resources_tab_${tab.title}`}
              >
                <HoverableArrow text={tab.title} showArrow={resourcesSelectedTab === i} />
              </a>
            ))}
          </section>
          <a className='w-auto h-auto group' href={selectedSection.link}>
            <section className='flex flex-col items-start leading-none'>
              <img
                src={selectedSection.image}
                alt={`image ${selectedSection.title}`}
                className='w-56 h-auto'
                style={{ boxShadow: '0 16px 32px rgba(0,0,0,0.5)', borderRadius: '14px' }}
              />
              <a href={selectedSection.link} className='mb-3 font-bold group-hover:underline mt-8'>
                {selectedSection.title}
              </a>
              <p>{selectedSection.description}</p>
            </section>
          </a>
        </div>
      </MegaMenuContent>
    </MegaMenu>
  )
}
